/**
 * User Account Functionality
 */
import { safeSelect } from './utils.js';


/**
 * Initialisiert die Login/Registrierungs-Funktionalität
 * @param {Object} options
 * @param {string} options.suffix - ID-Suffix dieser Formular-Instanz (z.B. '-register', '-modal'),
 *   damit mehrere Kopien (Account-Seite, Login-Overlay) unabhängig voneinander funktionieren.
 * @returns {{reset: Function}|undefined} Öffentliche Steuerfunktion(en) dieser Instanz
 */
export const initUserLogin = function({ suffix = '' } = {}) {
	try {
		const toggleButton = safeSelect(`#toggle-register-form${suffix}`);
		const registerForm = safeSelect(`#register-form${suffix}`);

		if (!toggleButton) {
			console.log('Button zum Öffnen des Registrierungsformulars nicht gefunden');
			return;
		}

		if (!registerForm) {
			console.log('Registrierungsformular nicht gefunden');
			return;
		}

		// Submit-Button finden
		const submitButton = safeSelect('button[type="submit"]', registerForm);

		// Initialer Zustand sicherstellen
		registerForm.style.display = 'none';
		toggleButton.style.display = 'block'; // Button ist sichtbar
		if (submitButton) {
			submitButton.disabled = true;
		}

		// Funktion zum Schließen des Formulars
		const closeRegisterForm = function() {
			registerForm.style.display = 'none';
			if (submitButton) {
				submitButton.disabled = true;
			}
			// Alle Input-Felder deaktivieren (zusätzliche Sicherheit)
			const inputs = registerForm.querySelectorAll('input, textarea');
			inputs.forEach(input => input.disabled = true);

			// Formular-Felder zurücksetzen
			registerForm.reset();

			// Button zum Öffnen wieder einblenden
			toggleButton.style.display = 'block';
		};

		// Funktion zum Öffnen des Formulars
		const openRegisterForm = function() {
			registerForm.style.display = 'block';
			if (submitButton) {
				submitButton.disabled = false;
			}
				// Alle Input-Felder aktivieren
				const inputs = registerForm.querySelectorAll('input, textarea');
				inputs.forEach(input => input.disabled = false);

				// Captcha-Bild neu laden (Klassen-basiert, subtree-scoped -> kollisionsfrei)
				const captchaImage = safeSelect('.form__captcha-img', registerForm);
				if (captchaImage) {
					const captchaSrc = captchaImage.src.split('?')[0];
					captchaImage.src = captchaSrc + '?t=' + new Date().getTime();
				}

			// Button zum Öffnen ausblenden
			toggleButton.style.display = 'none';

			// Fokus auf erstes Eingabefeld setzen
			const firstInput = safeSelect(`#field-name${suffix}`, registerForm);
			if (firstInput) {
				setTimeout(() => firstInput.focus(), 100);
			}
		};

		// Button Event (öffnet das Formular)
		toggleButton.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			openRegisterForm();
		});

		// Abbrechen-Button Event
		const cancelButton = safeSelect(`#cancel-register${suffix}`);
		if (cancelButton) {
			cancelButton.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				closeRegisterForm();
			});
		}


		console.log('Login-Funktionalität initialisiert' + (suffix ? ` (${suffix})` : ''));

		return { reset: closeRegisterForm };
	} catch (error) {
		console.error('Fehler bei der Initialisierung der Login-Funktionalität:', error);
	}
};

/**
 * Initialisiert die Account-Seite (Userpic-Vorschau)
 */
export const initUserAccount = function() {
	try {
		const userpicInput = safeSelect('#userpic');
		const userpicPreview = safeSelect('#userpic-preview');
		const userpicPlaceholder = safeSelect('#userpic-placeholder');
		
		if (userpicInput && userpicPreview && userpicPlaceholder) {
			userpicInput.addEventListener('change', function(e) {
				const file = e.target.files[0];
				
				if (file && file.type.startsWith('image/')) {
					const reader = new FileReader();
					
					reader.onload = function(e) {
						userpicPreview.src = e.target.result;
						userpicPreview.classList.remove('is-hidden');
						userpicPreview.classList.add('is-visible');
						userpicPlaceholder.classList.add('is-hidden');
					};
					
					reader.readAsDataURL(file);
				} else {
					// Zurücksetzen wenn keine gültige Datei
					userpicPreview.classList.remove('is-visible');
					userpicPreview.classList.add('is-hidden');
					userpicPlaceholder.classList.remove('is-hidden');
				}
			});
		}

		// Submit-News-Formular: Bildvorschau (ohne Placeholder)
		const fieldImageInput = safeSelect('#field-image');
		const fieldImagePreview = safeSelect('#field-image-preview');
		if (fieldImageInput && fieldImagePreview) {
			fieldImageInput.addEventListener('change', function(e) {
				const file = e.target.files[0];
				if (file && file.type.startsWith('image/')) {
					const reader = new FileReader();
					reader.onload = function(ev) {
						fieldImagePreview.src = ev.target.result;
						fieldImagePreview.classList.remove('is-hidden');
					};
					reader.readAsDataURL(file);
				} else {
					fieldImagePreview.removeAttribute('src');
					fieldImagePreview.classList.add('is-hidden');
				}
			});
		}
	} catch (error) {
		console.error('Fehler bei der Initialisierung der Account-Funktionalität:', error);
	}
};

